export const PHOTOFLIPPER_EVENTS = {
  TOGGLE: 'photoflipper_toggle',
};
